import Vue from 'vue'
import Router from 'vue-router'
import index from './../page/index.vue'
import bind from './../page/bind.vue'
import searchcust from './../page/searchcust.vue'
import yqjl from './../page/yqjl.vue'
import feeall from './../page/feeall.vue'
import jfjl from './../page/jfjl.vue'
import ybsf from './../page/ybsf.vue'
import qfjl from './../page/qfjl.vue'
import ycqf from './../page/ycqf.vue'
import ycjl from './../page/ycjl.vue'
import yqfx from './../page/yqfx.vue'
import bindlist from './../page/bindlist.vue'
import accountdetail from './../page/accountdetail.vue'
import gasprice from './../page/gasprice.vue'
import gasquality from './../page/gasquality.vue'
import businessguide from './../page/businessguide.vue'
import memo from './../page/memo.vue'
import wangdian from './../page/wangdian.vue'
import companyinfo from './../page/companyinfo.vue'
Vue.use(Router);

const routes = [
    {
        path:'/index',
        name:'index',
        component:index,
        meta:{ title: '首页' }
    },
    {
        path:'/',
        name:'index',
        component:index,
        meta:{ title: '首页' }
    },
    {
        path:'/bind',
        name:'bind',
        component:bind,
        meta:{ title: '绑定用户' }
    },
    {
        path:'/searchcust',
        name:'searchcust',
        component:searchcust,
        meta:{ title: '查询绑定' }
    },
    {
        path:'/yqjl',
        name:'yqjl',
        component:yqjl,
        meta:{ title: '用气记录' }
    },
    {
        path:'/feeall',
        name:'feeall',
        component:feeall,
        meta:{ title: '用气详情' }
    },
    {
        path:'/jfjl',
        name:'jfjl',
        component:jfjl,
        meta:{ title: '缴费记录' }
    },
    {
        path:'/ybsf',
        name:'ybsf',
        component:ybsf,
        meta:{ title: '一般收费' }
    },
    {
        path:'/accountdetail',
        name:'accountdetail',
        component:accountdetail,
        meta:{ title: '一般收费' }
    },
    {
        path:'/qfjl',
        name:'qfjl',
        component:qfjl,
        meta:{ title: '欠费记录' }
    },
    {
        path:'/ycqf',
        name:'ycqf',
        component:ycqf,
        meta:{ title: '预存气费' }
    },
    {
        path:'/ycjl',
        name:'ycjl',
        component:ycjl,
        meta:{ title: '预存记录' }
    },
    {
        path:'/bindlist',
        name:'bindlist',
        component:bindlist,
        meta:{ title: '用户绑定' }
    },
    {
        path:'/gasprice',
        name:'gasprice',
        component:gasprice,
        meta:{ title: '气价公示' }
    },
    {
        path:'/gasquality',
        name:'gasquality',
        component:gasquality,
        meta:{ title: '燃气质量' }
    },
    {
        path:'/businessguide',
        name:'businessguide',
        component:businessguide,
        meta:{ title: '业务指南' }
    },
    {
        path:'/memo',
        name:'memo',
        component:memo,
        meta:{ title: '装修须知' }
    },
    {
        path:'/wangdian',
        name:'wangdian',
        component:wangdian,
        meta:{ title: '网点信息' }
    },
    {
        path:'/companyinfo',
        name:'companyinfo',
        component:companyinfo,
        meta:{ title: '公司概况' }
    },
    {
        path:'/yqfx',
        name:'yqfx',
        component:yqfx,
        meta:{ title: '用气分析' }
    }
]
const router = new Router({
    routes
})

export default router;